"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'landing.nav.about': '关于系统',
    'landing.nav.modules': '模块',
    'landing.nav.assistants': 'AI助手',
    'landing.nav.contentStudio': '内容工作室',
    'landing.nav.analytics': '分析',
    'landing.nav.login': '登录',
    'landing.hero.eyebrow': '企业AI平台',
    'landing.hero.title1': '一个面板。',
    'landing.hero.title2': '所有AI模型',
    'landing.hero.title3': '为您的企业。',
    'landing.hero.lede': 'IntHub将GPT-5、Claude、Gemini和DeepSeek整合在一个地方——同时包含助手、内容规划、成本报告和团队管理。',
    'landing.hero.ctaLogin': '登录面板',
    'landing.hero.ctaModules': '查看模块',
    'landing.hero.note': 'testhub.intgate.io — 已登录企业可用的面板',
    'landing.hero.deviceTitle': '开始与您的AI助手对话',
    'landing.hero.deviceSub': '选择一个模型、写作风格并连接知识——只需一个命令。',
    'landing.hero.deviceInput': '/ 风格 · # 项目 · @ 知识 — 输入您的问题…',
    'landing.model.openai': 'OpenAI · GPT-5',
    'landing.model.claudeSonnet': 'Claude Sonnet 4.6',
    'landing.model.deepseek': 'DeepSeek V3.2',
    'landing.model.gemini': 'Gemini 3.5 Flash',
    'landing.model.claudeHaiku': 'Claude Haiku 4.5',
    'landing.intro.eyebrow': '介绍',
    'landing.intro.title': '整个组织的AI指挥中心',
    'landing.intro.lede1': 'IntHub将AI模型对话、虚拟助手、内容规划和成本报告整合在一个系统中。',
    'landing.intro.lede2': '系统从底层就是多租户的：一个管理员账户可以管理多个企业、行业和团队。',
    'landing.stat.providers': '4个提供商',
    'landing.stat.providersLab': 'OpenAI、Anthropic、DeepSeek、Google — 一个聊天界面',
    'landing.stat.roles': '3个角色',
    'landing.stat.rolesLab': '超级管理员、经理、用户 — 精确权限',
    'landing.stat.multitenant': '多租户',
    'landing.stat.multitenantLab': '一个系统中的多个企业、行业和团队',
    'landing.stat.credits': '积分',
    'landing.stat.creditsLab': '透明订阅模式中的AI使用计费',
    'landing.modules.eyebrow': '模块',
    'landing.modules.title': 'IntHub中究竟有什么',
    'landing.modules.lede': '九个模块，一个登录。',
    'landing.module.chat.title': '多模型AI聊天',
    'landing.module.chat.desc': '从一个窗口与GPT-5、Claude、Gemini或DeepSeek聊天。',
    'landing.module.assistants.title': '虚拟助手',
    'landing.module.assistants.desc': '创建具有自己个性、性别和AI模型的头像。',
    'landing.module.knowledge.title': '知识库',
    'landing.module.knowledge.desc': '将企业文档和数据连接到特定助手或项目。',
    'landing.module.contentStudio.title': '内容工作室',
    'landing.module.contentStudio.desc': '规划帖子、分配频道并跟踪状态。',
    'landing.module.styles.title': '写作风格',
    'landing.module.styles.desc': '保存品牌声音并与整个团队分享。',
    'landing.module.costs.title': '成本报告',
    'landing.module.costs.desc': '按用户、企业和时间段跟踪token和成本。',
    'landing.module.management.title': '企业和团队管理',
    'landing.module.management.desc': '管理具有单独模块、行业和职业的多个企业。',
    'landing.module.logs.title': '审计日志和访问',
    'landing.module.logs.desc': '每次创建和更新都会进入数据库日志。',
    'landing.module.pricing.title': '计划和付款',
    'landing.module.pricing.desc': '从免费计划到无限制的Ultra。',
    'landing.assistants.eyebrow': 'AI助手',
    'landing.assistants.title': '随企业成长的机器人团队',
    'landing.assistants.lede': '每个助手都是独立的AI员工。',
    'landing.assistants.feature1': '任何头像使用任何模型',
    'landing.assistants.feature2': '开始工作前的培训任务列表',
    'landing.assistants.feature3': '自己的知识库',
    'landing.avatar.historian': '历史学家',
    'landing.avatar.historianRole': 'Claude Sonnet 4.6',
    'landing.avatar.hive': 'HIVE助手',
    'landing.avatar.hiveRole': 'DeepSeek V3.2 · 开发者',
    'landing.avatar.communicator': '通讯员',
    'landing.avatar.communicatorRole': 'Gemini 3.5 Flash',
    'landing.avatar.whatsapp': 'Whatsapp',
    'landing.avatar.whatsappRole': 'Claude Haiku 4.5',
    'landing.avatar.statusConfig': '配置完成',
    'landing.cs.eyebrow': '内容工作室',
    'landing.cs.title': '从创意到发布，无需电子表格',
    'landing.cs.lede': '帖子库显示什么是草稿、什么等待批准、什么已经发布。',
    'landing.cs.feature1': '状态：草稿、已计划、待批准、已发布',
    'landing.cs.feature2': '日程和发布历史在一个地方',
    'landing.cs.feature3': 'AI助手根据参与度建议主题',
    'landing.cs.statScheduled': '已计划（7天）',
    'landing.cs.statApproval': '待批准',
    'landing.cs.statPublished': '已发布（30天）',
    'landing.cs.statTotal': '帖子总数',
    'landing.cs.postTitle': '测试API',
    'landing.cs.postStatus': '已发布',
    'landing.cs.postContent': '"你好！今天我们展示如何逐步测试API……"',
    'landing.cs.suggest1': '哪些主题会带来最好的参与度？',
    'landing.cs.suggest2': '为下周建议内容计划',
    'landing.cs.suggest3': '什么时候发布最好？',
    'landing.analytics.eyebrow': '分析',
    'landing.analytics.title': '每个token都精确到分',
    'landing.analytics.lede': '按日期、用户、头像或企业筛选成本报告。',
    'landing.analytics.feature1': '按日期、用户、头像和企业筛选',
    'landing.analytics.feature2': '成本和token趋势图',
    'landing.analytics.feature3': '组织中最活跃头像排名',
    'landing.analytics.totalCost': '总成本',
    'landing.analytics.tokens': 'Token',
    'landing.analytics.messages': '消息',
    'landing.analytics.avgCost': '平均成本/消息',
    'landing.analytics.topMessages': '顶级头像消息',
    'landing.analytics.topAvatar': '顶级头像',
    'landing.management.eyebrow': '管理和安全',
    'landing.management.title': '多企业结构，每层控制',
    'landing.management.lede': '一个安装管理多个企业、行业和职业。',
    'landing.management.companies.title': '企业、用户、角色',
    'landing.management.companies.desc': '添加具有NIP、地址和分配模块的企业。',
    'landing.management.logs.title': '数据库审计日志',
    'landing.management.logs.desc': '按日期、模型和操作类型筛选日志。',
    'landing.management.table.company': '企业',
    'landing.management.table.city': '城市',
    'landing.management.table.status': '状态',
    'landing.management.table.model': '模型',
    'landing.management.table.operation': '操作',
    'landing.management.table.date': '日期',
    'landing.management.company1': 'Studio Nord Sp. z o.o.',
    'landing.management.company2': 'Kancelaria Wschód',
    'landing.management.company3': 'Biuro Rachunkowe Miller',
    'landing.management.warsaw': '华沙',
    'landing.management.krakow': '克拉科夫',
    'landing.management.elk': 'Ełk',
    'landing.management.active': '活跃',
    'landing.management.opConversation': '对话',
    'landing.management.opMessage': '消息',
    'landing.management.opCurrency': '汇率',
    'landing.management.opCreate': '创建',
    'landing.management.opUpdate': '更新',
    'landing.cta.eyebrow': '准备启动',
    'landing.cta.title': '今天在企业中集中AI',
    'landing.cta.lede': '登录测试面板并在几分钟内配置您的第一个助手。',
    'landing.cta.button': '前往登录',
    'landing.footer.copyright': '© 2026 IntHub. 保留所有权利。',
    'landing.footer.panel': '登录面板',
    'landing.img.logo': 'IntHub',
    'landing.img.bg1': 'AI工作站',
};
